export const URL = "https://backoffice.filoprint.ro/api";
export const URLPOZE = "https://backoffice.filoprint.ro";
// export const URL = "https://localhost:44308/api";
// export const URLPOZE = "https://localhost:44308";

export const FE_URL = "http://localhost:3000";
export const regions = [
  { value: "București", label: "București" },
  { value: "Alba", label: "Alba" },
  { value: "Arad", label: "Arad" },
  { value: "Argeș", label: "Argeș" },
  { value: "Bacău", label: "Bacău" },
  { value: "Bihor", label: "Bihor" },
  { value: "Bistrița-Năsăud", label: "Bistrița-Năsăud" },
  { value: "Botoșani", label: "Botoșani" },
  { value: "Brașov", label: "Brașov" },
  { value: "Brăila", label: "Brăila" },
  { value: "Buzău", label: "Buzău" },
  { value: "Caraș-Severin", label: "Caraș-Severin" },
  { value: "Călărași", label: "Călărași" },
  { value: "Cluj", label: "Cluj" },
  { value: "Constanța", label: "Constanța" },
  { value: "Covasna", label: "Covasna" },
  { value: "Dâmbovița", label: "Dâmbovița" },
  { value: "Dolj", label: "Dolj" },
  { value: "Galați", label: "Galați" },
  { value: "Giurgiu", label: "Giurgiu" },
  { value: "Gorj", label: "Gorj" },
  { value: "Harghita", label: "Harghita" },
  { value: "Hunedoara", label: "Hunedoara" },
  { value: "Ialomița", label: "Ialomița" },
  { value: "Iași", label: "Iași" },
  { value: "Ilfov", label: "Ilfov" },
  { value: "Maramureș", label: "Maramureș" },
  { value: "Mehedinți", label: "Mehedinți" },
  { value: "Mureș", label: "Mureș" },
  { value: "Neamț", label: "Neamț" },
  { value: "Olt", label: "Olt" },
  { value: "Prahova", label: "Prahova" },
  { value: "Satu Mare", label: "Satu Mare" },
  { value: "Sălaj", label: "Sălaj" },
  { value: "Sibiu", label: "Sibiu" },
  { value: "Suceava", label: "Suceava" },
  { value: "Teleorman", label: "Teleorman" },
  { value: "Timiș", label: "Timiș" },
  { value: "Tulcea", label: "Tulcea" },
  { value: "Vâlcea", label: "Vâlcea" },
  { value: "Vaslui", label: "Vaslui" },
  { value: "Vrancea", label: "Vrancea" },
];

export const roles = {
  CLIENT: "Client",
  ADMIN: "Admin",
};

export const orderTaxes = {
  shipping: 15,
  cash: 10,
};

export const orderTaxesNames = {
  shipping: "shipping",
  pickUp: "personal",
  cash: "cash",
  card: "card",
  transfer: "transfer",
};

export const paymentStatus = {
  PAID: "Plătit",
  UNPAID: "Neplătit",
  REFUNDED: "Returnat",
  PENDING: "În așteptare",
  CARD_PENDING: "Plata card realizată",
  CARD_CREATED: "Plata deschisă",
  DECLINED: "Refuzat",
};

export const statusValues = {
  NEW: "Nou",
  IN_PROGRESS: "In prelucrare",
  DELIVERED: "Livrat",
  CANCELED: "Anulat",
};
